module.exports = __webpack_public_path__ + "img/ranking2.c08994ac.png";